// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__33Jrv","legacyBtn":"MutateMid_legacyBtn__nsfAv"};